export enum dashboardTabs{
    SpeedDials = 'speedDials',
    DialPad = 'dialPad',
    CallHistory = 'callHistory'
}
